export default "__VITE_ASSET__BGMJyZzK__"